import axios from "axios";
import type { FRQItem } from "../../types/FRQItem";

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/rfqs`;

export interface SearchOffersParams {
  limitValue: number;
  currentPage: number;
  search: string;
  statusFilter?: string;
  column?: string;
  sort?: "ASC" | "DESC";
}

export interface SearchOffersTotal {
  total: number;
}

export const searchRfqOffers = async (
  params: SearchOffersParams
): Promise<FRQItem[]> => {
  const response = await axios.post(`${API_BASE_URL}/search-offers`, params);
  return Array.isArray(response.data) ? response.data : [];
};

export const countRfqOffers = async (
  params: SearchOffersParams
): Promise<SearchOffersTotal> => {
  const response = await axios.post(
    `${API_BASE_URL}/search-offers/totalpage`,
    params
  );
  return response.data || { total: 0 };
};